import { getShouldHideConnectCTA } from '@modules/integrationsV2/utils';
import { HelpOutlineRounded } from '@mui/icons-material';
import { Box, IconButton } from '@mui/material';
import { IntegrationChannelViewFragment } from 'generated/graphql';
import { getInstructionsUrlForChannel } from 'modules/ui/Settings/Integrations/utils/getInstructionsUrlForChannel';

interface DrawerIntegrationCardLeftActionsProps {
  integrationChannel: IntegrationChannelViewFragment;
}

export const DrawerIntegrationCardLeftActions = ({
  integrationChannel,
}: DrawerIntegrationCardLeftActionsProps) => {
  const helpCenterInstructionsURL =
    getInstructionsUrlForChannel(integrationChannel);

  const onHelpButtonClick = () => {
    window.open(helpCenterInstructionsURL, '_blank');
  };

  const shouldHideConnectCTA = getShouldHideConnectCTA(integrationChannel);

  return (
    <Box>
      {helpCenterInstructionsURL && !shouldHideConnectCTA && (
        <IconButton size="small" onClick={onHelpButtonClick}>
          <HelpOutlineRounded fontSize="small" color="primary" />
        </IconButton>
      )}
    </Box>
  );
};
